import * as tf from '@tensorflow/tfjs';
import * as speechCommands from '@tensorflow-models/speech-commands'
import { toRaw } from 'vue'
import {save} from './saveTmModel.js'
import { normalize, flattenQueue, getInputTensorFromFrequencyData } from '@/tm/Audio/scripts/audio.js';

export default class CustomTmAudio{
    constructor() {
        this.model = null
        this._stopTraining = false
    }

    async train(labels, dataset, params = {epochs: 50}, callback){
        this._stopTraining = false;
        const baseModel = toRaw(speechCommands.create('BROWSER_FFT'));
        await baseModel.ensureModelLoaded();
        this.model = baseModel.createTransfer('transfer') //Object.freeze(this.baseModel.createTransfer('transfer'))
        await this.addData(dataset, labels)
        const rawModel = toRaw(this.model)
        await rawModel.train({
            epochs: params.epochs,
            callback: {
                onEpochEnd: async (epoch, logs) => {
                    const realEpoch = epoch + 1;
                    callback(`Epoch: ${realEpoch} / ${params.epochs}`, realEpoch / params.epochs)
                    console.log(`Epoch ${epoch}: loss=${logs.loss}, accuracy=${logs.acc}`);
                    if (this._stopTraining) {
                        this.model.model.stopTraining=true;
                        console.log("Stopped training early");
                        callback(``, 1)
                    }
                }
            }
        });

        rawModel.metadataOrURL = {
            "tfjsSpeechCommandsVersion":"0.4.0",
            "modelName":"TMv2",
            "timeStamp": new Date().toISOString(),
            "wordLabels": labels
        }

        return this.model
    }

    stopTraining(){
        this._stopTraining = true;
    }

    async save(){
        return await save(toRaw(this.model.model), this.model.metadataOrURL);
    }

    async listen(callback){
        await this.model.listen(predict => {
            const words = this.model.wordLabels();
            const result = words.map((word, index) => {
                return { className: word, probability: predict.scores[index] };
            });
            /* console.log(result) */
            /* callback(result) */
        }, {probabilityThreshold: 0.75});
    }

    async stopListening(){
        if (this.model) {
            await this.model.stopListening();
        }
    }

    async addData(dataset, labels){
        const maxNumber = labels.length
        const width = String(maxNumber).length; // 計算最大數字的長度
        const numbers = Array.from({ length: maxNumber }, (_, i) => 
            String(i + 1).padStart(width, '0')
        );

        for(let i = 0; i < dataset.length; i++){
            const label = numbers[i]
            console.log(label, dataset[i].length)
            for(let j = 0; j < dataset[i].length; j++){
                const spectrogram = dataset[i][j].normalizedX

                await this.model.dataset.addExample({
                    label: label,
                    spectrogram: {
                        data: spectrogram,
                        frameSize: 232,
                    }
                })
            }
        }

        this.model.words = labels
    }

    async loadUrl({modelUrl, metadataUrl}){
        const model = toRaw(speechCommands.create("BROWSER_FFT", undefined, modelUrl, metadataUrl))
        await model.ensureModelLoaded();
        this.loadRaw(model)
    }

    async loadFile({modelFile, metadata, weightsFiles}){
        const modelArtifacts = await tf.io.browserFiles([modelFile, ...weightsFiles]).load()
        await this.loadUrl({modelUrl: modelArtifacts, metadataUrl: metadata});
    }

    async loadRaw(model){
        this.model =  model;
    }

    async predict(spectrogramData){
        if (this.model) {
            const shape = [1, 43, 232, 1]
            const freqData = flattenQueue(spectrogramData)
            const freqDataTensor = getInputTensorFromFrequencyData(freqData, shape);
            const normalizedX = normalize(freqDataTensor);
            const output = await this.model.model.predict(normalizedX);
            const scores = await output.data();
            const maxIndexTensor = output.argMax(-1);
            tf.dispose([output, maxIndexTensor, normalizedX]);
            return scores;
        } else {
            return null
        }
    }

    async test(){
        const url = "https://teachablemachine.withgoogle.com/models/y1cdlEOzk/"
        const modelUrl = url + "model.json";
        const metadataUrl = url + "metadata.json";
        await this.loadUrl({modelUrl: modelUrl, metadataUrl: metadataUrl})
        return this
    }
}